import { render, staticRenderFns } from "./visitorPerformanceStatistics.vue?vue&type=template&id=50036fde&scoped=true&"
import script from "./visitorPerformanceStatistics.vue?vue&type=script&lang=js&"
export * from "./visitorPerformanceStatistics.vue?vue&type=script&lang=js&"
import style0 from "./visitorPerformanceStatistics.vue?vue&type=style&index=0&id=50036fde&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50036fde",
  null
  
)

export default component.exports